import React from 'react';
import LearningCard from '../components/LearningCard';

const RushHourHosts = () => (
  <LearningCard
    testid="rushhour-hosts"
    title="Rush Hour – Hosts"
    subtitle="Microlearning"
    support={[
      'Tijdens Rush Hour draait alles om timing, duidelijke uitleg en gastgerichte begeleiding. In deze microlearning ontdek je hoe het event werkt, welke zones wanneer actief zijn en hoe je gasten op het juiste moment naar de juiste plek verwijst.',
      'Op donderdag 14 mei en vrijdag 15 mei staat Maasmechelen Village in het teken van Rush Hour. Ontdek hoe je gasten verwelkomt, het Members-only moment uitlegt, de juiste zone aanwijst en Rush Hour Flavours actief vermeldt.',
    ]}
    buttons={[
      {
        label: 'Open de microlearning',
        href: 'https://app.qoldo.com/p/395ebe7d-649f-4ac6-876b-c4e257f98f5e?t=c9d1aeb1-6340-487b-a439-d9bda192ee33',
        testid: 'btn-open-microlearning',
      },
    ]}
  />
);

export default RushHourHosts;
